// 基于数组数据 绘制

import { addLayerExist } from '../layerStatusControl'
var orbitList = {}
var orbitNumList = {}

const defaultStyle = {
  // 线颜色
  color: '#FFFFFF',
  // 线宽度
  width: 3,
  // 线边框宽度
  outlineWidth: 2,
  // 线边框颜色
  outlineColor: '#FFFFFF'
}
function addSatOrbLayer (layerInfo, viewer) {
  // 设置 entity存储
  const _id = layerInfo.id

  orbitList[_id] = []
  orbitNumList[_id] = []
  // 获取数据
  const lineData = layerInfo.data
  // 样式
  const style = layerInfo.style || defaultStyle
  // 添加数据
  lineData.forEach(item => {
    if (item[0]) {
      const color = item[0][3] || '#000000'
      const orbNum = item[0][4] || null
      const lineMark = addSatOrbLine(item, viewer, style)
      if (lineMark) {
        orbitList[_id].push(lineMark)
      }
      const numberMark = addSatOrbNum(item, viewer, orbNum)
      if (numberMark) {
        orbitNumList[_id].push(numberMark)
      }
    }
  })

  const addInfo = {
    info: layerInfo,
    layer: null,
    market: null
  }
  addLayerExist(addInfo)
}

function addSatOrbLine (source, viewer, style) {
  // 点阵列表
  const pointList = []

  for (let i = 0; i < source.length; i++) {
    const point = source[i]
    pointList.push(parseFloat(point[0]).toFixed(4))
    pointList.push(parseFloat(point[1]).toFixed(4))
    pointList.push(Number(point[2]))
  }
  // 颜色转化为 cesium 颜色
  const color = style.color || '#FFFFFF'
  const colorInCesium = Cesium.Color.fromCssColorString(color)

  const outlineColor = style.outlineColor || '#FFFFFF'
  const outlineColorInCesium = Cesium.Color.fromCssColorString(outlineColor)

  if (pointList.length > 0) {
    const positions = Cesium.Cartesian3.fromDegreesArrayHeights(pointList)
    const satOrbitLine = viewer.entities.add({
      name: 'sat line',
      polyline: {
        positions: positions,
        width: style.width || 2,
        arcType: Cesium.ArcType.RHUMB,
        material: new Cesium.PolylineOutlineMaterialProperty({
          color: colorInCesium,
          outlineWidth: style.outlineWidth || 2,
          outlineColor: outlineColorInCesium
        })
      }
    })
    return satOrbitLine
  }
  return null
}

function removeSatOrbLayer (layerInfo, viewer) {
  const _id = layerInfo.id
  if (orbitList[_id]) {
    const entitiesList = orbitList[_id]
    entitiesList.forEach(lineItem => {
      viewer.entities.remove(lineItem)
    })
  }
  removeSatOrbNum(layerInfo, viewer)
}

// 添加轨道号
function addSatOrbNum (source, viewer, orbNum) {
  // 添加轨道号
  if (orbNum) {
    const index = parseInt(source.length / 2)
    const satNumPoint = source[index]
    const lon = parseFloat(satNumPoint[0]).toFixed(4)
    const lat = parseFloat(satNumPoint[1]).toFixed(4)
    const height = (Number(satNumPoint[2])) * 1.1
    orbNum = orbNum.toString()
    const satOrbitNumber = viewer.entities.add({
      position: Cesium.Cartesian3.fromDegrees(lon, lat, height),
      label: {
        text: orbNum,
        font: '24px Helvetica',
        fillColor: Cesium.Color.SKYBLUE,
        outlineColor: Cesium.Color.BLACK,
        outlineWidth: 2,
        style: Cesium.LabelStyle.FILL_AND_OUTLINE,
        // scaleByDistance: new Cesium.NearFarScalar(1.5e2, 2.0, 1.5e7, 1)
      }
    })
    return satOrbitNumber
  }
  return null
}

// 移除轨道号
function removeSatOrbNum (layerInfo, viewer) {
  const _id = layerInfo.id
  if (orbitList[_id]) {
    const entitiesList = orbitNumList[_id]
    entitiesList.forEach(lineItem => {
      viewer.entities.remove(lineItem)
    })
  }
}

export { addSatOrbLayer, removeSatOrbLayer }
